export const SELECTS_placeholder = {
  COMMUNITY: 'Seleccione comunidad',
  PROVINCE: 'Seleccione provincia',
  LOCATION: 'Seleccione localidad' // COMMUNITY: 'Seleccione comunidad',

};